import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import jwt_decode from 'jwt-decode';
import styles from './SignupPage.module.css';
import Button from '../../components/Button';
import InputField from '../../components/InputField';
import LoginCard from '../../components/LoginCard';
import LoginHeader from '../../components/LoginHeader';
import FlexBetween from '../../components/utils/FlexBetween';
import server from '../../apis/server';

const SignupPage = () => {
  const { setIsLoggedIn } = useContext(UserContext);

  const [isFetching, setIsFetching] = useState(false);
  const [username, setUsername] = useState('');
  const [realName, setRealName] = useState('');
  const [password, setPassword] = useState('');

  const onFormSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsFetching(true);
      const res = await server.post('/user/register', {
        username,
        full_name: realName,
        password,
      });

      setIsFetching(false);

      localStorage.setItem('token', res.data.token);

      setIsLoggedIn(jwt_decode(res.data.token));
    } catch (err) {
      setIsFetching(false);
    }
  };

  return (
    <div className={styles.page}>
      <LoginCard onSubmit={onFormSubmit}>
        <FlexBetween style={{ marginBottom: '1rem' }}>
          <Link to="/signup">
            <LoginHeader text="Sign Up" active />
          </Link>
          <Link to="/login">
            <LoginHeader text="Log in" />
          </Link>
        </FlexBetween>
        <InputField
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <InputField
          placeholder="Real name"
          onChange={(e) => setRealName(e.target.value)}
          value={realName}
        />
        <InputField
          placeholder="Password"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
        />
        <Button text="Sign Up" type="submit" isFetching={isFetching} />
      </LoginCard>
    </div>
  );
};

export default SignupPage;
